import './App.css';
import { useAuth0 } from '@auth0/auth0-react';
import { CopilotKit } from "@copilotkit/react-core";

// imports relevant for HTTP calls
import DisplayException from './error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from './config_server_url';

// import user session information
import UserSessionContext from './user_session/context_user_session';

// imports for app basic appearance
import AppHeader from './app_layout/header/AppHeader';

// imports for Routes 
import CreateNewProject from './create_new_project/CreateNewProject';
import AllProjects from './all_projects/AllProjects';
import PageProjectInformation from './current_project/project_information/PageProjectInformation';
import PageCampaignBuilder from './current_project/campaign_builder/PageCampaignBuilder';
import PageOptimizationCampaigns from './current_project/optimization_campaigns/PageOptimizationCampaigns';
import PageProjectData from './current_project/project_data/PageProjectData';
import PageCampaignSetup from './current_campaign/campaign_setup/PageCampaignSetup';
import PageOptimizationCycles from './current_campaign/optimization_cycles/PageOptimizationCycles';
import PageCampaignData from './current_campaign/campaign_data/PageCampaignData';
import PageCampaignTreeView from './current_campaign/campaign_tree_view/PageCampaignTreeView';
import PageProjectTreeView from './current_project/project_tree_view/PageProjectTreeView';
//import ProjectContext from './context/ProjectContext';
import {Route, Routes } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';

import LoginPage from './user_login/LoginPage';
import SelectWorkspace from './user_login/SelectWorkspace';


function App() {
    const [isLoading, setIsLoading] = useState(true);
    const [Exception, setException] = useState(false);
    const [isSelectWorkspace, setIsSelectWorkspace ] = useState(false);
    const [availableWorkspaces, setAvailableWorkspaces ] = useState([]);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    const usr_session_ctx = useContext(UserSessionContext);
    const { user, isAuthenticated, isLoading: isLoadingAuth0} = useAuth0();



    function load_user_session(uuid_tenant){
        setIsLoading(true);
        fetch(`${SERVER_URL}/user_session/initialize/`, {
            method: "GET",
            headers:{'auth0_user': user.sub,
                     'uuid_tenant': uuid_tenant
             }
        })
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((user_session) => {
            if(user_session.msg !== '') {
                setException(true);
                setExceptionMessage(`ServerError: err_msg=${user_session.msg}`);
            }
            else{
                usr_session_ctx.uuid_tenant = user_session.data.uuid_tenant;
                usr_session_ctx.session_info = user_session.data.session_info;
                setIsLoading(false); 
            }
        })
        .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
    }


    function load_available_workspaces(){
        setIsLoading(true);
        fetch(`${SERVER_URL}/user_session/load_available_workspaces/`, {
            method: "GET",
            headers:{'auth0_user': user.sub }
        })
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((available_workspaces) => {
            setAvailableWorkspaces(available_workspaces.data);
            if(available_workspaces.data.length === 1){
                load_user_session(available_workspaces.data[0].uuid);
            }
            setIsLoading(false); 
        })
        .catch((err) => {
            setException(true);
            setIsLoading(false);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
    }



    useEffect(  () => {
        if (isAuthenticated && !isSelectWorkspace) {
            load_available_workspaces();
        }
    }, [isAuthenticated, isSelectWorkspace]);



    function handleSelect(event){
        const uuid_tenant = event.target.id
        load_user_session(uuid_tenant)
        setIsSelectWorkspace(true)
    }

    if (isLoadingAuth0){
        return(
        <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%', border:'1px solid black'}}>
            <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
        </div>);
    }
    
    if (!isAuthenticated && !isLoadingAuth0) {
        return (<LoginPage />);
    }

    if (isAuthenticated){
    // Exection and Error Messeges Get Priority and Are Evaluated Before Anything els
        if(Exception){
            return (<>
                    <AppHeader />
                    <DisplayException>
                        {ExceptionMessage}
                    </DisplayException>  
                </>)
        }
        else if(isLoading){
            return (
                <>
                    {/* <AppHeader /> */}
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%', border:'1px solid black'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </>);
        }
        else if (!isLoading && !isSelectWorkspace && availableWorkspaces.length>1) {
            return (<SelectWorkspace workspaces={availableWorkspaces}
                                     select={handleSelect} />);     
        }

        else {   
            return (
                <>
                    <AppHeader />
                    <CopilotKit publicApiKey="ck_pub_823989d717e7ec3e48bb6bd17f8c96b0">
                    <Routes>
                        <Route path='/create_new_project' element={<CreateNewProject />} />
                        <Route path='/' element={<PageProjectInformation />} />
                        <Route path='/all_projects' element={<AllProjects />} />
                        <Route path='/campaign_builder' element={<PageCampaignBuilder />} />
                        <Route path='/optimization_campaigns' element={<PageOptimizationCampaigns />} />
                        <Route path='/project_data' element={<PageProjectData />} />
                        <Route path='/project_tree_view' element={<PageProjectTreeView />} />
                        <Route path='/active_campaign_setup' element={<PageCampaignSetup />} />
                        <Route path='/optimization_cycles' element={<PageOptimizationCycles />} />
                        <Route path='/campaign_data' element={<PageCampaignData />} />
                        <Route path='/campaign_tree_view' element={<PageCampaignTreeView />} />
                    </Routes>
                    </CopilotKit>
                </>);
        }

    }

}

export default App;
